import { Value } from "@/Models/Eav";
import clsx from "clsx";
import { Marker } from "react-mark.js";

interface PropertyMultiValueRowsProps {
    prop: Value;
    category: string;
    pIdx: number;
    debouncedSearch: string;
}

const PropertyMultiValueRows = ({ prop, category, pIdx, debouncedSearch }: PropertyMultiValueRowsProps) => {
    if (!prop.values || prop.values.length <= 1) return null;

    return prop.values.map((value, index) => (
        <div
            key={`${category}-${prop.attr.Name}-${value.id}-${index}`}
            className={clsx(
                "flex px-8 border-b",
                { "border-t": index === 0 },
                { "bg-slate-50 dark:bg-slate-800": pIdx % 2 }
            )}
        >
            <div className="w-2/5 p-1 text-slate-500">
                <Marker as="small" mark={debouncedSearch}>
                    {value.id}
                </Marker>
            </div>
            <div className="w-3/5 p-1">
                <Marker as="small" mark={debouncedSearch}>
                    {value.value}
                </Marker>
            </div>
        </div>
    ));
};

export default PropertyMultiValueRows;
